import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GocaptchaComponent } from 'src/app/components/login/gocaptcha/gocaptcha.component';
import { OverseasPhoneDialogComponent } from 'src/app/components/login/overseas-phone-dialog/overseas-phone-dialog.component';
import { WxloginModalComponent } from 'src/app/components/wxlogin-modal/wxlogin-modal.component';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';
import { WxService } from 'src/app/services/wx.service';
import { validateEmail, validateLoginPhone, validatePhone } from 'src/app/utils/string';
declare var gtag: any;

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent {
  method = 'Phone';
  methodEmail = 'Email1';

  constructor(
    private api: UserApiService,
    private message: MessageService,
    private user: UserService,
    private router: Router,
    private wx: WxService,
    private dialog: MatDialog,
  ) {
  }

  mode: string = 'phone';
  email: string = '';
  phone: string = '';
  code: string = '';
  password: string = '';
  agree = false;
  usePhone() {
    this.method = 'Phone';
  }

  usePassword() {
    this.method = 'Password';
  }

  timeout = 0;

  onPhoneKeydown(event: KeyboardEvent) {
    if (this.method === 'Phone' && event.key === '+') {
      event.preventDefault();
      this.openOverseasDialog();
    }
  }

  onPhoneInput(event: any) {
    if (this.method !== 'Phone') {
      return;
    }
    const value = event.target.value || '';
    // 含 +（海外区号）→ 清空 + 弹
    if (value.includes('+')) {
      const cleaned = value.replace(/\+/g, '');
      this.phone = cleaned;
      event.target.value = cleaned;
      this.openOverseasDialog();
      return;
    }
    // 非空且第一个字符不是 1 → 非国内手机号，清空并弹
    if (value && value.charAt(0) !== '1') {
      this.phone = '';
      event.target.value = '';
      this.openOverseasDialog();
    }
  }

  openOverseasDialog() {
    this.dialog
      .open(OverseasPhoneDialogComponent, {
        panelClass: 'overseas-phone-dialog',
        autoFocus: false,
        width: '480px',
        maxWidth: '94vw',
      })
      .afterClosed()
      .subscribe((r) => {
        if (r === 'email') {
          this.switchMode('email');
        } else if (r === 'password') {
          this.usePassword();
        }
      });
  }

  sendCode() {
    this.dialog
      .open(GocaptchaComponent)
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.message.clear();

          this.phone = this.phone.trim();
          if (!this.phone) {
            return;
          }
          if (!validatePhone(this.phone)) {
            this.openOverseasDialog();
            return;
          }
          this.sendLoginCode(this.phone);
        }
      });
  }

  loading = false;
  async sendLoginCode(phone: string) {
    if (this.timeout > 0 || this.loading) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.sendLoginCode(phone);
      if (r.status === 1002) {
        this.message.open('账号已封禁，无法登录', { position: 'top' });
      } else if (r.status === 1001) {
        this.timeout = r.data;
        this.message.open('发送过快', { position: 'top' });
      } else if (r.status === 1000) {
        this.message.open('发送失败', { position: 'top' });
      } else if (r.status !== 0) {
        this.message.open('未知错误', { position: 'top' });
      } else {
        this.timeout = r.data;
      }
      this.tick();
    } catch (error) {
      this.message.open('网络错误', { position: 'top' });
    } finally {
      this.loading = false;
    }
  }

  tick() {
    if (this.timeout <= 0) {
      return;
    }
    var i = setInterval(() => {
      this.timeout -= 1;
      if (this.timeout <= 0) {
        clearInterval(i);
      }
    }, 1000);
  }

  login() {
    this.message.clear();
    this.phone = this.phone.trim();
    this.code = this.code.trim();
    this.password = this.password.trim();

    if (!this.phone) {
      this.message.warn('请输入手机号', { position: 'top' });
      return;
    } else if (!this.code && this.method === 'Phone') {
      this.message.warn('请输入验证码', { position: 'top' });
      return;
    } else if (!this.password && this.method === 'Password') {
      this.message.warn('请输入密码', { position: 'top' });
      return;
    }
    if (this.method === 'Phone') {
      if (!validatePhone(this.phone)) {
        this.openOverseasDialog();
        return;
      }
    } else {
      if (!validateLoginPhone(this.phone)) {
        this.message.warn('请输入有效的手机号', {
          position: 'top',
        });
        return;
      }
    }
    if (!this.agree) {
      this.message.warn('请先同意隐私协议和用户协议', { position: 'top' });
      return;
    }
    if (this.method === 'Phone') {
      this.loginByPhone(this.phone, this.code);
    } else {
      this.loginByPassword(this.phone, this.password);
    }
    sessionStorage.removeItem('qhclickid');
  }

  async loginByPhone(phone: string, code: string) {
    try {
      this.loading = true;
      const qhclickid = sessionStorage.getItem('qhclickid') || '';
      const r = await this.api.loginByPhone(phone, code, qhclickid);
      if (r.status === 1002) {
        this.message.warn('账号被封禁，不能登录', { position: 'top' });
      } else if (r.status === 1003) {
        this.message.warn('验证码错误', { position: 'top' });
      } else if (r.status !== 0) {
        this.message.warn('未知错误', { position: 'top' });
      } else {
        this.user.setSelf(r.data);
        if (!r.data.know_password_change)
          sessionStorage.setItem('showFirstPasswordModal', '1');
        window.location.href = '/';
        gtag('event', 'login');
      }
    } catch (error) {
      this.message.error('网络错误', { position: 'top' });
    } finally {
      this.loading = false;
    }
  }

  async loginByPassword(phone: string, password: string) {
    try {
      this.loading = true;
      const qhclickid = sessionStorage.getItem('qhclickid') || '';
      const r = await this.api.loginByPassword(phone, password, qhclickid);
      if (r.status === 1002) {
        this.message.warn('账号被封禁，不能登录', { position: 'top' });
      } else if (r.status === 1010) {
        this.message
          .warn('手机号不存在，请先使用手机号注册', {
            position: 'top',
          })
          .onAction()
          .subscribe(() => {
            this.method = 'Phone';
            this.code = '';
          });
      } else if (r.status === 1011) {
        this.message.warn('密码错误', { position: 'top' });
      } else if (r.status !== 0) {
        this.message.warn('未知错误', { position: 'top' });
      } else {
        this.user.setSelf(r.data);
        if (!r.data.know_password_change)
          sessionStorage.setItem('showFirstPasswordModal', '1');
        window.location.href = '/';
        gtag('event', 'login');
      }
    } catch (error) {
      this.message.error('网络错误', { position: 'top' });
    } finally {
      this.loading = false;
    }
  }

  loginWxQrcode() {
    // window.location.href = this.wx.authQrcode('login');
    this.dialog.open(WxloginModalComponent, {
      data: 'login',
    });
  }

  async loginByEmail(email: string, code: string) {
    try {
      this.loading = true;
      const qhclickid = sessionStorage.getItem('qhclickid') || '';
      const r = await this.api.loginByEmail(email, code, qhclickid);
      if (r.status === 1002) {
        this.message.warn('账号被封禁，不能登录', { position: 'top' });
      } else if (r.status === 1003) {
        this.message.warn('验证码错误', { position: 'top' });
      } else if (r.status !== 0) {
        this.message.warn('未知错误', { position: 'top' });
      } else {
        this.user.setSelf(r.data);
        if (!r.data.know_password_change)
          sessionStorage.setItem('showFirstPasswordModal', '1');
        window.location.href = '/';
        gtag('event', 'login');
      }
    } catch (error) {
      this.message.error('网络错误', { position: 'top' });
    } finally {
      this.loading = false;
    }
  }

  async loginByEmailPassword(email: string, password: string) {
    try {
      this.loading = true;
      const qhclickid = sessionStorage.getItem('qhclickid') || '';
      const r = await this.api.loginByEmailPassword(email, password, qhclickid);
      if (r.status === 1002) {
        this.message.warn('账号被封禁，不能登录', { position: 'top' });
      } else if (r.status === 1016) {
        this.message
          .warn('邮箱不存在，请先使用邮箱注册', {
            position: 'top',
          })
          .onAction()
          .subscribe(() => {
            this.methodEmail = 'Email1';
            this.code = '';
          });
      } else if (r.status === 1011) {
        this.message.warn('密码错误', { position: 'top' });
      } else if (r.status !== 0) {
        this.message.warn('未知错误', { position: 'top' });
      } else {
        this.user.setSelf(r.data);
        if (!r.data.know_password_change)
          sessionStorage.setItem('showFirstPasswordModal', '1');
        window.location.href = '/';
        gtag('event', 'login');
      }
    } catch (error) {
      this.message.error('网络错误', { position: 'top' });
    } finally {
      this.loading = false;
    }
  }

  async sendLoginCodeEmail(email: string) {
    if (this.timeout > 0 || this.loading) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.sendLoginCodeEmail(email);
      if (r.status === 1002) {
        this.message.open('账号已封禁，无法登录', { position: 'top' });
      } else if (r.status === 1001) {
        this.timeout = r.data;
        this.message.open('发送过快', { position: 'top' });
      } else if (r.status === 1000) {
        this.message.open('发送失败', { position: 'top' });
      } else if (r.status !== 0) {
        this.message.open('未知错误', { position: 'top' });
      } else {
        this.timeout = r.data;
      }
      this.tick();
    } catch (error) {
      this.message.open('网络错误', { position: 'top' });
    } finally {
      this.loading = false;
    }
  }

  sendCodeEmail() {
    this.dialog
      .open(GocaptchaComponent)
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.message.clear();

          this.email = this.email.trim();
          if (!this.email) {
            return;
          }
          if (!validateEmail(this.email)) {
            this.message.warn('请输入有效的邮箱号', {
              position: 'top',
            });
            return;
          }
          this.sendLoginCodeEmail(this.email);
        }
      });
  }

  switchMode(mode: string) {
    if (this.mode !== mode) {
      this.mode = mode;
      this.phone = '';
      this.email = '';
      this.code = '';
      this.password = '';
      this.timeout = 0;
      this.agree = false;
    }
  }

  loginEmail() {
    this.message.clear();
    this.email = this.email.trim();
    this.code = this.code.trim();
    this.password = this.password.trim();

    if (!this.email) {
      this.message.warn('请输入邮箱', { position: 'top' });
      return;
    } else if (!this.code && this.methodEmail === 'Email1') {
      this.message.warn('请输入验证码', { position: 'top' });
      return;
    } else if (!this.password && this.methodEmail === 'Email2') {
      this.message.warn('请输入密码', { position: 'top' });
      return;
    }
    if (!validateEmail(this.email)) {
      this.message.warn('请输入有效的邮箱', {
        position: 'top',
      });
      return;
    } else if (!this.agree) {
      this.message.warn('请先同意隐私协议和用户协议', { position: 'top' });
      return;
    }
    if (this.methodEmail === 'Email1') {
      this.loginByEmail(this.email, this.code);
    } else {
      this.loginByEmailPassword(this.email, this.password);
    }
    sessionStorage.removeItem('qhclickid');
  }

  useEmail1() {
    this.methodEmail = 'Email1';
  }

  useEmail2() {
    this.methodEmail = 'Email2';
  }
}
